import React from 'react';

const Filters = ({ filter, setFilter, stats }) => {
  return (
    <div className="filters">
      <div className="filter-buttons">
        <button
          onClick={() => setFilter('all')}
          className={`filter-btn ${filter === 'all' ? 'active active-all' : ''}`}
        >
          All ({stats.total})
        </button>
        <button
          onClick={() => setFilter('attempted')}
          className={`filter-btn ${
            filter === 'attempted' ? 'active active-attempted' : ''
          }`}
        >
          ✅ Solved ({stats.attempted})
        </button>
        <button
          onClick={() => setFilter('starred')}
          className={`filter-btn ${
            filter === 'starred' ? 'active active-starred' : ''
          }`}
        >
          ⭐ Favorites ({stats.starred})
        </button>
        <div className="filter-divider"></div>
        {['Easy', 'Medium', 'Hard'].map((diff) => (
          <button
            key={diff}
            onClick={() => setFilter(diff)}
            className={`filter-btn ${
              filter === diff ? `active active-${diff.toLowerCase()}` : ''
            }`}
          >
            {diff}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Filters;